module.exports = __webpack_public_path__ + "img/gongzh.512cc042.jpg";